export default __webpack_public_path__ + "img/ESG-Consulting.77145565.webp";